// HomeGlow Nails - Mock Data

export const businessInfo = {
  name: "HomeGlow Nails",
  tagline: "Luxury Nail Art, Cozy Home Comfort",
  description: "Premium nail artistry in a relaxed, private setting. Experience the luxury of professional nail care in the comfort of my home studio.",
  location: "Kitchener, Ontario, Canada",
  address: "123 Maple Street, Kitchener, ON N2H 1A1",
  phone: "+1 (519) 555-0123",
  email: "hello@homeglownails.com",
  whatsapp: "+15195550123",
  instagram: "@homeglownails",
  instagramUrl: "https://instagram.com/homeglownails",
  hours: {
    weekdays: "9:00 AM - 7:00 PM",
    saturday: "10:00 AM - 6:00 PM",
    sunday: "By Appointment Only"
  }
};

export const services = [
  {
    id: 1,
    name: "Classic Manicure",
    description: "A timeless treatment including nail shaping, cuticle care, hand massage, and polish application.",
    duration: "45 min",
    price: 35,
    category: "manicure",
    image: "https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxuYWlsJTIwc2Fsb258ZW58MHx8fHwxNzY5MTQzNTE4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Gel Manicure",
    description: "Long-lasting gel polish that stays chip-free for up to 3 weeks with brilliant shine.",
    duration: "60 min",
    price: 55,
    category: "manicure",
    popular: true,
    image: "https://images.unsplash.com/photo-1599316329891-19df7fa9580d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBuYWlsJTIwYXJ0fGVufDB8fHx8MTc2OTE0MzUwOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Luxury Spa Manicure",
    description: "An indulgent experience with exfoliation, paraffin treatment, extended massage, and premium polish.",
    duration: "75 min",
    price: 75,
    category: "manicure",
    image: "https://images.unsplash.com/photo-1762373349045-c2decd4ec3f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwbWFuaWN1cmV8ZW58MHx8fHwxNzY5MTQzNTEzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Nail Art Design",
    description: "Express yourself with custom nail art designs, from minimalist accents to intricate patterns.",
    duration: "30+ min",
    price: 15,
    priceNote: "per nail",
    category: "art",
    popular: true,
    image: "https://images.unsplash.com/photo-1589047951904-8721626ed51c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBuYWlsJTIwYXJ0fGVufDB8fHx8MTc2OTE0MzUwOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    name: "Acrylic Full Set",
    description: "Durable acrylic extensions sculpted to your desired length and shape, with polish.",
    duration: "90 min",
    price: 85,
    category: "extensions",
    image: "https://images.unsplash.com/photo-1767961054375-1de154a9cec1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbWFuaWN1cmV8ZW58MHx8fHwxNzY5MTQzNTEzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    name: "Gel-X Extensions",
    description: "Soft gel tips for a natural look with flexible, lightweight feel. Includes gel polish.",
    duration: "75 min",
    price: 95,
    category: "extensions",
    popular: true,
    image: "https://images.unsplash.com/photo-1704775988111-3aa9c705b57c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwbWFuaWN1cmV8ZW58MHx8fHwxNzY5MTQzNTEzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    name: "Fill-In Service",
    description: "Maintenance for acrylic or gel extensions. Keep your nails looking fresh and flawless.",
    duration: "60 min",
    price: 55,
    category: "extensions",
    image: "https://images.unsplash.com/photo-1619607146034-5a05296c8f9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxuYWlsJTIwc2Fsb258ZW58MHx8fHwxNzY5MTQzNTE4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    name: "Gel Removal",
    description: "Safe, gentle removal of gel polish or extensions with nail conditioning treatment.",
    duration: "30 min",
    price: 20,
    category: "other",
    image: "https://images.unsplash.com/photo-1690749138086-7422f71dc159?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxuYWlsJTIwc2Fsb258ZW58MHx8fHwxNzY5MTQzNTE4fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1768767115625-69d3c41f7bb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBuYWlsJTIwYXJ0fGVufDB8fHx8MTc2OTE0MzUwOHww&ixlib=rb-4.1.0&q=85",
    title: "Elegant Sparkle",
    category: "nail art"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1599316329891-19df7fa9580d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBuYWlsJTIwYXJ0fGVufDB8fHx8MTc2OTE0MzUwOHww&ixlib=rb-4.1.0&q=85",
    title: "Classic White",
    category: "gel manicure"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1589047951904-8721626ed51c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBuYWlsJTIwYXJ0fGVufDB8fHx8MTc2OTE0MzUwOHww&ixlib=rb-4.1.0&q=85",
    title: "Luxury Details",
    category: "nail art"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1762373349045-c2decd4ec3f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwbWFuaWN1cmV8ZW58MHx8fHwxNzY5MTQzNTEzfDA&ixlib=rb-4.1.0&q=85",
    title: "French Elegance",
    category: "french manicure"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1767961054375-1de154a9cec1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbWFuaWN1cmV8ZW58MHx8fHwxNzY5MTQzNTEzfDA&ixlib=rb-4.1.0&q=85",
    title: "Bridal Beauty",
    category: "special occasion"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1704775988111-3aa9c705b57c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwbWFuaWN1cmV8ZW58MHx8fHwxNzY5MTQzNTEzfDA&ixlib=rb-4.1.0&q=85",
    title: "Sophisticated Style",
    category: "gel manicure"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1767881897090-2242aa03c869?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwbWFuaWN1cmV8ZW58MHx8fHwxNzY5MTQzNTEzfDA&ixlib=rb-4.1.0&q=85",
    title: "Timeless Beauty",
    category: "classic manicure"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxuYWlsJTIwc2Fsb258ZW58MHx8fHwxNzY5MTQzNTE4fDA&ixlib=rb-4.1.0&q=85",
    title: "Studio Vibes",
    category: "experience"
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1610992015762-45dca7fa3a85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxuYWlsJTIwc2Fsb258ZW58MHx8fHwxNzY5MTQzNTE4fDA&ixlib=rb-4.1.0&q=85",
    title: "Perfect Polish",
    category: "gel manicure"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Waterloo",
    rating: 5,
    text: "Absolutely love my nails! The attention to detail is incredible. The home studio is so relaxing and private. Best nail experience I've ever had!",
    service: "Gel-X Extensions"
  },
  {
    id: 2,
    name: "Emily R.",
    location: "Kitchener",
    rating: 5,
    text: "Found my forever nail artist! The quality is amazing and the cozy atmosphere makes every appointment feel like a treat.",
    service: "Nail Art Design"
  },
  {
    id: 3,
    name: "Jessica L.",
    location: "Cambridge",
    rating: 5,
    text: "My gel manicure lasted over 3 weeks with no chips! So impressed with the professionalism and skill. Highly recommend!",
    service: "Gel Manicure"
  },
  {
    id: 4,
    name: "Amanda K.",
    location: "Kitchener",
    rating: 5,
    text: "The luxury spa manicure was worth every penny. Left feeling pampered and my hands have never looked better!",
    service: "Luxury Spa Manicure"
  }
];

export const timeSlots = [
  "9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM",
  "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM",
  "5:00 PM", "6:00 PM"
];

export const aboutContent = {
  story: "Welcome to HomeGlow Nails, where luxury meets comfort in the heart of Kitchener. I'm passionate about creating beautiful, personalized nail art in a relaxed, private setting.",
  mission: "My mission is to provide exceptional nail services that make you feel confident and pampered. Every appointment is a one-on-one experience, ensuring you receive my full attention and care.",
  experience: "With over 5 years of experience in nail artistry, I specialize in gel manicures, nail extensions, and custom nail art designs. I continuously update my skills with the latest techniques and trends.",
  whyChoose: [
    {
      title: "Private & Cozy",
      description: "Enjoy a peaceful, one-on-one experience in my home studio."
    },
    {
      title: "Premium Products",
      description: "Only the highest quality, long-lasting polishes and products."
    },
    {
      title: "Hygienic & Safe",
      description: "Strict sanitation protocols with sterilized tools for every client."
    },
    {
      title: "Personalized Service",
      description: "Custom designs tailored to your style and preferences."
    }
  ]
};
